export default __webpack_public_path__ + "static/media/run_matching.21702103.svg";